module.exports = __webpack_public_path__ + "img/google.2640d830.svg";